<template>
  <div class="contain page6-con" id="Mobile6">
    <div class="con">
      <div class="con-head title-box">
        <div class="title-chinese">
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
          <h3>名录</h3>
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
        </div>
        <div class="title-english">
          <p class="about" style="color: #666">LISTS</p>
        </div>
      </div>
      <div class="content myMain">
        <div class="title">
          <i class="line"></i>
          <h3>名录</h3>
        </div>
        <ul>
          <li
            v-for="(item, index) in directoriesData"
            :key="index"
            v-html="item.title"
            class="vHtml-directories"
            @click="gotoDetail(item)"
          ></li>
        </ul>
        <div class="btn-box">
          <router-link to="/directoryMore" tag="button">查看更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from "@/api/home/index";
import { removeHtmlStyle } from "@/utils/removestyle";
export default {
  data() {
    return {
      params: {
        categorys: '名录',
         show: 1,
      },
      directoriesData: [],
    };
  },
  created() {
    getArticleList(this.params).then((res) => {
      const filterCaseData = res.data.list.filter(
        (item) => item.highlight == 1
      );
      this.directoriesData = filterCaseData.filter((item, index) => index < 6);
    });
  },
  methods: {
    removeHtmlStyle,
    gotoDetail(item){
      this.$router.push('/article/articleDetail?type=directory&id=' + item.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.page6-con {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.page6-con .con {
  height: 100%;
  overflow: hidden;
  padding-top: 80px;
  padding-bottom: 60px;
  box-sizing: border-box;
  .con-head .el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .el-col-6 {
      width: 20%;
    }
    .el-col {
      h3 {
        font-size: 38px;
        color: #da5351;
      }
      .line {
        width: 85px;
        height: 2px;
        background-color: #d8d8d8;
        display: none;
      }
      .line:last-child {
        margin-top: 2px;
      }
    }
    p.about {
      font-size: 18px;
      margin-top: 16px;
      margin-bottom: 60px;
    }
  }
  .con-head {
    height: 15%;
  }
  .content {
    background-color: #f5f5f5;
    margin: 0 auto;
    border-radius: 4px;
    padding: 40px;
    box-sizing: border-box;
    text-align: left;

    div.title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      i {
        width: 4px;
        height: 28px;
        background-color: #da5351;
      }

      h3 {
        font-size: 28px;
        margin-left: 20px;
        font-weight: normal;
        color: #222222;
      }
    }
    ul > li {
      text-align: left;
      font-size: 18px;
      color: #222222;
      line-height: 18px;
      margin-bottom: 24px;
      position: relative;
      cursor: pointer;
      padding-left: 20px;
      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        background-color: #222222;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 6px;
      }
    }
    button {
      width: 140px;
      height: 52px;
      background-color: #da5351;
      border-radius: 26px;
      border: none;
      color: #fff;
      font-size: 20px;
      margin-top: 6px;
      cursor: pointer;
    }
  }
}
//移动端
@media screen and (max-width: 960px) {
  #Mobile6 {
    .con {
      padding-top: 0.24rem;
      padding: 0.24rem 0.16rem 0.24rem 0.16rem;
    }
    .content {
      padding: 0.14rem;
      .title {
        margin-bottom: 0.12rem;
        .line {
          width: 0.02rem;
          height: 0.12rem;
          background: #da5351;
        }
        h3 {
          font-size: 0.16rem;
          font-weight: 500;
          color: #222222;
          line-height: 0.28rem;
          margin-left: 0.1rem;
        }
      }
      ul {
        li {
          font-size: 0.14rem;
          color: #454545;
          line-height: 0.14rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.14rem;
          padding-left: .2rem;
          &:nth-child(n + 6) {
            display: none;
          }
        }
      }
      .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        button {
          width: 0.76rem;
          height: 0.3rem;
          background: #cc3b3f;
          border-radius: 0.3rem;
          font-size: 0.12rem;
          margin: 0;
        }
      }
    }
  }
}
</style>



<style lang="scss">
//html的样式
.vHtml-directories {
  p {
    text-align: left;
    font-size: 18px;
    color: #222222;
    line-height: 18px;
    margin-bottom: 24px;
    margin-left: 20px;
  }
}
@media screen and (max-width: 960px) {
  #Mobile6 {
    .vHtml-directories {
      &::before {
        width: 0.04rem;
        height: 0.04rem;
        left: 0.06rem;
        top: 25%;
      }
      p {
        font-size: 0.14rem;
        font-weight: 400;
        color: #454545;
        line-height: 0.14rem;
        margin-bottom: 0.14rem;
        margin-left: 0.2rem;
      }
    }
  }
}
</style>